<template>
    <div class="container container-tabs">
        <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
            <el-tab-pane name="all" class="to-searh">
                <span slot="label" class="table-title">全部</span>
            </el-tab-pane>

            <el-tab-pane :name="String(item.val)" v-for="(item, index) in status_select" :key="index" class="to-searh">
                <span slot="label" class="table-title">{{ item.alias }}</span>
            </el-tab-pane>

            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="24" style="margin: 10px 0">
                        <span class="title">合作模式 : </span>
                        <el-radio-group v-model="search_data.partner_mode" size="small">
                            <el-radio label="" border>全部</el-radio>
                            <el-radio label="1" border>已开启</el-radio>
                            <el-radio label="0" border>已关闭</el-radio>
                        </el-radio-group>
                    </el-col>

                    <el-col :span="24" style="margin: 10px 0">
                        <span class="title">自创单模式 : </span>
                        <el-radio-group v-model="search_data.wait_mode" size="small">
                            <el-radio label="" border>全部</el-radio>
                            <el-radio label="1" border>已开启</el-radio>
                            <el-radio label="0" border>已关闭</el-radio>
                        </el-radio-group>
                    </el-col>
                </el-row>

                <el-button type="primary" icon="el-icon-search" @click="searchModelLists">搜索</el-button>
                <el-button @click="addBtn">添加</el-button>
                <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            </div>
        </el-tabs>

        <!-- 表格 -->
        <el-table
            :data="tableData"
            style="width: 100%"
            ref="multipleTable"
            header-cell-class-name="table-header"
            @selection-change="handleSelectionChange"
        >
            <el-table-column prop="city.name" label="城市名称" width="300"> </el-table-column>
            <!-- <el-table-column prop="order_mode_qrcode" label="二维码" min-width="120">
                <template slot-scope="scope">
                    <el-image
                        style="width: 80px; height: 80px; border: 1px solid #eee; border-radius: 5px"
                        :src="scope.row.order_mode_qrcode"
                        v-if="scope.row.order_mode_qrcode != ''"
                        :preview-src-list="srcList"
                    >
                    </el-image>
                </template>
            </el-table-column> -->

            <el-table-column prop="name" label="名称" width="150"> </el-table-column>

            <el-table-column prop="port.alias" label="端口"> </el-table-column>

            <el-table-column prop="partner_mode.alias" label="合作模式">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.partner_mode.val === '0' ? 'info' : 'warning'">
                        {{ scope.row.partner_mode.alias }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column prop="wait_mode.alias" label="自创单模式">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.wait_mode.val === '0' ? 'info' : ''">
                        {{ scope.row.wait_mode.alias }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column prop="wait_mode.alias" label="恶劣天气模式">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.is_sleet.val === '0' ? 'info' : ''">
                        {{ scope.row.is_sleet.alias }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column label="管理状态">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status.val === '0' ? 'info' : 'success'">
                        {{ scope.row.status.alias }}
                    </el-tag>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <el-dropdown
                        split-button
                        type="primary"
                        @click="editModel(scope.row.order_mode.order_mode_code, scope.row.city.name, scope.row.status.alias)"
                        trigger="click"
                    >
                        编辑模式

                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="editModeCoordinate(scope.row.order_mode.order_mode_code)"
                                >订单模式围栏
                            </el-dropdown-item>

                            <el-dropdown-item @click.native="toDetil(scope.row.order_mode.order_mode_code)">模式预览 </el-dropdown-item>

                            <el-dropdown-item @click.native="delOrder(scope.row.order_mode.order_mode_code)">删除模式 </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>

        <!-- 编辑模式组件 和添加页面共用一个组件-->
        <editOrderModel
            :btnType="btnType"
            :data="drivingModel_dialog"
            :drivingModel_select="drivingModel_select"
            :isShow="editModel_isShow"
            @onSubmit="modelLists"
        ></editOrderModel>

        <!-- 订单模式围栏组件 -->
        <editModeCoordinate :isShow="editModeCoordinate_isShow" :data="editModel_dialog" @onSubmit="modelLists"></editModeCoordinate>

        <el-dialog :visible.sync="iframe_show" width="50%">
            <iframeModel :isShow="iframe_show" :param="iframe_param" :iframe_url="iframe_url" style="height: 60vh"> </iframeModel>

            <div style="text-align: center">
                <el-button @click="iframe_show = false" class="close-btn">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
var _this;

import editOrderModel from './editOrderModel.vue';
import editModeCoordinate from './editModeCoordinate.vue';

import iframeModel from '../../common/iframe.vue';
import { config } from '../../../utils/config.js'; //配置
export default {
    components: {
        editOrderModel,

        iframeModel,
        editModeCoordinate
    },
    data() {
        return {
            btnType: '', // 区分添加和编辑按钮
            // 修改模式组件开关
            editModel_isShow: false,

            editModeCoordinate_isShow: false,
            editModel_dialog: '',

            iframe_show: false,
            iframe_url:
                'http://192.168.0.40:8080/#/pages/modeInfo/modeInfo?app_version=1.0.1&platform=pc&port=admin&token=&order_mode_code=',
            iframe_param: '',

            // 传入子组件的数据

            drivingModel_dialog: {
                order_mode_code: ''
            },

            // 传入子组件的数据(下拉显示内容)
            drivingModel_select: {
                city: '',
                status: ''
            },

            // 选项卡默认选中项
            activeName: 'all',

            status_select: [],

            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                status: '',
                wait_mode: '',
                partner_mode: ''
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.searchModelLists();
        _this.iframe_url = config.h5;
    },

    methods: {
        // 添加方法
        addBtn() {
            _this.btnType = 'add';

            _this.editModel_isShow = !_this.editModel_isShow;
        },
        editModeCoordinate(code) {
            _this.editModeCoordinate_isShow = !_this.editModeCoordinate_isShow;
            _this.editModel_dialog = code;
        },
        searchModelLists() {
            _this.search_data.page = 1;
            _this.modelLists();
        },

        toDetil(code) {
            _this.iframe_show = true;
            _this.iframe_param = code;
        },

        // 选项卡选中事件
        handleClick(tab, event) {
            // 点击的选项卡所对应的val值

            if (tab.name != 'all') {
                _this.search_data.status = tab.name;
            } else {
                _this.search_data.status = '';
            }

            _this.modelLists();
        },

        editModel(code, city, status) {
            _this.btnType = 'edit';
            _this.drivingModel_dialog = code;
            _this.drivingModel_select.city = city;
            _this.drivingModel_select.status = status;
            _this.editModel_isShow = !_this.editModel_isShow;
        },

        // 获取模式
        modelLists() {
            _this
                .$post('/order/orderModeLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;

                    // 状态下拉的数据
                    _this.status_select = _this.tableData[0].status.select_array;
                })
                .catch((err) => {});
        },

        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;

            //初始化列表
            _this.modelLists();
        },

        handleSelectionChange(val) {
            var datalist = [];

            for (var i in val) {
                datalist.push(val[i].order_mode_code);
            }
            _this.delModelSubmit_data.order_mode_code = datalist;
        },

        //删除功能 city_code 跟super端不一致
        delOrder(code) {
            _this
                .$confirm('此操作将删除该条数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',

                    cancelButtonText: '取消',

                    type: 'warning'
                })
                .then(() => {
                    _this
                        .$post('/order/delOrderModeSubmit', {
                            order_mode_code: code,
                            city_code: JSON.parse(localStorage.getItem('login')).city.city_code,
                    
                        })
                        .then((res) => {
                            _this.modelLists();
                            _this.$message.success('删除成功');
                        })
                        .catch((err) => {});
                })
                .catch(() => {
                    _this.$message.info('已取消删除');
                });
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 200px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}

.content-body {
    display: flex;
    flex-wrap: wrap;
}

.content-body .el-form-item {
    width: 30%;
}
</style>
